import { SelectionTypeEnum } from "./SelectionTypeEnum";
import { Year } from "./Year";

export class PeriodDefinition {
    yearList: Year[];
    selectionType: SelectionTypeEnum;
    isRequired: boolean;

    constructor(yearList: Year[], selectionType: SelectionTypeEnum, isRequred: boolean) {
        this.yearList = yearList ?? [];
        this.selectionType = selectionType;
        this.isRequired = isRequred;
    }
}
